
class Request {
  getCurrentUrl() {
    return window.location.href;
  }
  
  getClientTimestamp() {
    return Math.floor(new Date().getTime() / 1000);
  }
  
  getRequestData() {
    return {
      request: {
        url: this.getCurrentUrl(),
        client_timestamp: this.getClientTimestamp(),
      },
    };
  }
}

export default new Request();
